'use strict';
import './secureCredit.scss';
import controller from './secureCredit.controller';

function directive() {
    return {
        restrict: 'EA',
        controller,
        controllerAs:'$ctrl',
        link: function (scope, element, attr, ctrl) {
        }
    };
}

export default directive;
